import React from "react";
import { Chart, Geom, Axis, Tooltip } from "bizcharts";
import { Empty } from "antd";

function BacklinksChart({ chartData }) {
  // TODO: move tickFormatter function to an utils file

  const tickFormatter = (val) => {
    val = parseFloat(val);
    if (val >= 1000000000) {
      val = val / 1000000000;
      return val.toFixed(1) + " B";
    }
    if (val >= 1000000) {
      val = val / 1000000;
      return val.toFixed(1) + " M";
    }
    if (val >= 1000) {
      val = val / 1000;
      return val.toFixed(1) + " K";
    }
    if (!val) {
      return val;
    }

    return val.toFixed(1);
  };

  const getMaxAndMinValueFromChartData = (_) => {
    let range = {
      min: 0,
      max: 0
    };

    if (chartData.length > 0) {
      let values = chartData.map((item) => item.value);
      range.min = Math.min(...values);
      range.max = Math.max(...values);
    }
    return range;
  };

  const getDifference = (_) => {
    let range = getMaxAndMinValueFromChartData();
    let { min, max } = range;

    let difference = max - min;
    if (difference === 0) {
      return max / 2;
    }

    if (difference > min) {
      return 0;
    }
    return difference;
  };

  const getScale = () => {
    let scale = {
      value: {
        type: "linear",
        min: getMaxAndMinValueFromChartData().min - getDifference(),
        max: getMaxAndMinValueFromChartData().max + getDifference(),
        formatter: (val) => tickFormatter(val),
        tickCount: 5
      },
      c_at: {
        type: "timeCat",
        mask: "MMM DD",
        tickCount: chartData.length
      }
    };

    if (chartData.length > 1) {
      scale["c_at"]["range"] = [0, 1];
    }
    return scale;
  };

  return (
    <React.Fragment>
      {chartData.length > 0 ? (
        <div className="backlinks-overview-chart" style={{ marginTop: "32px" }}>
          <Chart
            padding="auto"
            height={250}
            data={chartData}
            scale={getScale()}
            animate={false}
            forceFit
            onTooltipChange={(event) => {
              let tooltipItems = event.items;
              tooltipItems.forEach((item, idx) => {
                tooltipItems[idx].value = parseInt(tooltipItems[idx].point._origin.value).toLocaleString();
              });
            }}>
            <Axis name="c_at" />
            <Axis name="value" nice={false} />
            <Tooltip />
            <Geom type="line" position="c_at*value" size={2} color={["type", "#4BB2C5"]} />
            <Geom
              type="point"
              position="c_at*value"
              size={4}
              shape={"circle"}
              color={["type", "#4BB2C5"]}
              style={{
                lineWidth: 1
              }}
            />
          </Chart>
        </div>
      ) : (
        <Empty className="empty-state" image={Empty.PRESENTED_IMAGE_SIMPLE} description="No data for this interval" />
      )}
    </React.Fragment>
  );
}

export default BacklinksChart;
